/**
 * SITE MODE SWITCH — one setting controls whether the site takes bookings.
 *
 * ✏️ HOW TO FLIP IT (for Julio & Nick):
 *   Netlify dashboard → Site configuration → Environment variables →
 *   REACT_APP_SITE_MODE = one of:
 *     "live"             → normal site, pickup form open
 *     "bookings-paused"  → site stays up, pickup form becomes a waitlist
 *     "maintenance"      → whole site replaced by a "launching soon" page
 *   Then ask Claude to redeploy (the value is baked in at build time).
 *   If the variable is missing, the site runs "live".
 */

export type SiteMode = "live" | "bookings-paused" | "maintenance";

const raw = (process.env.REACT_APP_SITE_MODE || "live").trim().toLowerCase();
export const SITE_MODE: SiteMode =
  raw === "bookings-paused" || raw === "maintenance" ? (raw as SiteMode) : "live";

export const BOOKINGS_OPEN = SITE_MODE === "live";
